import type { ISavedSearchWebhookTableRow } from "../types/webhook";

const createEmptyWebhookRow = (): Omit<ISavedSearchWebhookTableRow, "index" | "isDeleteDisabled"> => ({
    key: `new-webhook-${crypto.randomUUID()}`,
    id: null,
    url: "",
    queryId: "",
});

export default createEmptyWebhookRow;
